import { Component, computed, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RouteStore } from 'app/state-management/route/route.store';
import { UrlUtils } from 'app/utils/url-utils';
import { ThemeService } from 'app/services/theme/theme.service';
import { ComputedBrandLogo } from 'app/services/theme/theme.models';
import { UserView } from 'app/models/user-views';
import { LicenseFeatureFlag } from 'app/models/license';
import { LicenseMode } from 'app/models/api/api-response';
import { FeatureFlagService } from 'app/services/feature-flag.service';
import { ProfileStore } from 'app/state-management/profile/profile.store';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureOnDirective } from 'app/directives/feature-on.directive';
import { OptimizedImageSourceDirective } from 'app/directives/optimized-image-source.directive';
import { UserViewDirective } from 'app/directives/user-view.directive';
import { UserPopOverComponent } from 'app/components/layout/user-pop-over/user-pop-over.component';

@Component({
  selector: 'sma-web-navigation',
  templateUrl: 'navigation.component.html',
  styleUrls: ['navigation.component.scss'],
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    FeatureOnDirective,
    OptimizedImageSourceDirective,
    UserViewDirective,
    UserPopOverComponent,
  ],
})
export class NavigationComponent {
  private themeService: ThemeService = inject(ThemeService);
  private featureFlagService: FeatureFlagService = inject(FeatureFlagService);
  protected readonly routeStore = inject(RouteStore);
  protected readonly profileStore = inject(ProfileStore);

  appLogo$: Observable<string | null> = this.themeService.appLogo$;
  brandLogo$: Observable<ComputedBrandLogo> = this.themeService.brandLogo$;
  exportTabUrl = computed((): string | null =>
    UrlUtils.resolveExportTabUrl(this.routeStore.url(), this.routeStore.isExportWizardOpen()));
  loadingLicenses$: Observable<boolean> = this.featureFlagService.licenseFeaturesLoading$;

  mobileNavigationState: number = 0;

  readonly UserView: typeof UserView = UserView;
  readonly LicenceFeatureFlag: typeof LicenseFeatureFlag = LicenseFeatureFlag;
  protected readonly LicenseMode: typeof LicenseMode = LicenseMode;
}
